
import { useState } from '@wordpress/element';
import { InspectorControls } from '@wordpress/block-editor';
import { TabPanel } from "@wordpress/components";
import ProModal from './ProModal';
import Patterns from './Patterns/Patterns';
import General from './General/General';
import Style from './Style/Style';
import { tabs } from '../../../utils/options';



const Settings = (props) => {
    const isPremium = Boolean(bsbpipecheck ?? false);
    const { clientId, attributes, setAttributes, addSlider, removeSlider, duplicateSlider, activeIndex, setActiveIndex, allCategories, multipleAttrChange, updateObject } = props;

    const [proModalOpen, setProModalOpen] = useState(false);

    const premiumProps = { isPremium, setIsProModalOpen: setProModalOpen };
    // general props 
    const generalProps = { attributes, setAttributes, addSlider, removeSlider, duplicateSlider, activeIndex, setActiveIndex, updateObject, allCategories, multipleAttrChange, premiumProps };
    // style props 
    const styleProps = { attributes, setAttributes, setProModalOpen, updateObject, multipleAttrChange, premiumProps };
    // patterns props
    const patternsProps = { clientId, premiumProps };

    return <> <InspectorControls style={{ marginBottom: "40px" }}>
        <TabPanel className="bPlTabPanel bsb-tab-panel" activeClass="activeTab" tabs={tabs}>
            {(tab) => <>
                {'General' == tab.name && <>
                    <General {...generalProps} />
                </>}

                {'style' == tab.name && <>
                    <Style {...styleProps} />
                </>}

                {"patterns" === tab.name && <>
                    <Patterns {...patternsProps} />
                </>}
            </>}
        </TabPanel>
    </InspectorControls>
        <ProModal setProModalOpen={setProModalOpen} proModalOpen={proModalOpen} />
    </>
}
export default Settings;